module.exports = __webpack_public_path__ + "img/mq.b675c1ae.svg";